import { FC } from 'react';
import { getThemesComponent } from '@namespace/themes';
import { SelectTriggerProps } from '../../../../types';
import { SelectTrigger as DefaultSelectTrigger } from './SelectTrigger';

interface SelectTrigger extends SelectTriggerProps {
  isCustomLanguageSelect?: boolean;
  label?: string;
}

export const SelectTrigger: FC<SelectTrigger> = (props) => {
  const { isCustomLanguageSelect = false, ...restProps } = props;

  if (!isCustomLanguageSelect) {
    return <DefaultSelectTrigger {...restProps} />;
  }

  const Component = getThemesComponent(
    DefaultSelectTrigger,
    'LanguageSelectTrigger'
  );
  return <Component {...restProps} />;
};
